import styled, { css } from 'styled-components'

import { Reset, TransitionPrimary } from '@/lib/mixins'

interface ButtonWrapperProps {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'red' | 'link' | 'light'
  size?: 'lg' | 'sm'
  block?: boolean
}

export const ButtonWrapper = styled.button<ButtonWrapperProps>`
  ${Reset('button')}
  ${TransitionPrimary()}
  font-weight: 600;
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  border: 1px solid transparent;
  height: 4rem;
  min-width: 10rem;
  padding: 0 2rem;
  font-size: 1.1rem;
  line-height: 1;
  white-space: nowrap;

  ${props =>
    props.variant === 'primary' &&
    css`
      background-color: ${props => props.theme.color.primary};
      color: ${props => props.theme.color.inverted};

      ${props =>
        props.theme.contrastMode &&
        css`
          background-color: ${props => props.theme.color.global};
          color: ${props => props.theme.color.dark};
        `};
    `};

  ${props =>
    props.variant === 'secondary' &&
    css`
      border-color: ${props => props.theme.color.primary};
      color: ${props => props.theme.color.primary};

      ${props =>
        props.theme.contrastMode &&
        css`
          border-color: ${props => props.theme.color.global};
          color: ${props => props.theme.color.global};
        `};
    `};

  ${props =>
    props.variant === 'tertiary' &&
    css`
      border-color: ${props => props.theme.color.line};
      color: ${props => props.theme.color.primary};

      ${props =>
        props.theme.contrastMode &&
        css`
          border-color: ${props => props.theme.color.global};
          color: ${props => props.theme.color.global};
        `};
    `};

  ${props =>
    props.variant === 'light' &&
    css`
      border-color: ${props => props.theme.color.primary};
      color: ${props => props.theme.color.primary};

      ${props =>
        props.theme.contrastMode &&
        css`
          border-color: ${props => props.theme.color.global};
          color: ${props => props.theme.color.global};
        `};
    `};

  ${props =>
    props.variant === 'red' &&
    css`
      border: 1px solid ${props => props.theme.color.red};
      color: ${props => props.theme.color.red};
    `};

  ${props =>
    props.variant === 'link' &&
    css`
      border: 0;
      color: var(--color-global);
    `};

  ${props =>
    props.block &&
    css`
      width: 100%;
      display: flex;

      & + & {
        margin-top: 0.5rem;
      }
    `};

  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `};

  ${props =>
    props.size === 'sm' &&
    css`
      height: 3rem;
      min-width: 8rem;
      padding: 0 1.5rem;
      font-size: 0.9rem;
    `};

  ${props =>
    props.size === 'lg' &&
    css`
      height: 6rem;
      min-width: 16rem;
      padding: 0 2rem;
      font-size: 1.25rem;
    `};
`

export const ButtonBadge = styled.span`
  display: inline-block;
  padding: 0.25em 0.5em;
  letter-spacing: 0;
  font-size: 0.9em;
  background-color: var(--color-inverted);
  border-radius: 1em;
  color: var(--color-global);
  margin-left: 0.5rem;
`
